const FILTRO_EMPTY = () => {
  return {
    simplificado: true,
    campoSimples: '',
    idMunicipiosGleba: [],
    ids: [],
    dataCadastro: null,
    nomeCartorio: '',
    idMunicipiosCartorio: [],
    matricula: '',
    dataMatricula: null,
    pagina: 0,
    ordem: 'id',
    numeroProcesso: '',
    nomeRazaoSocial: '',
    cpfCnpjInteressado: '',
    idMunicipiosProcesso: []
  }
}

export default FILTRO_EMPTY



// WEBPACK FOOTER //
// ./src/screens/bancoDados/models/filtroGleba.js